import CityPageTemplate from "../city-template/CityPageTemplate";
import { annapolisConfig } from "./data";

export default function AnnapolisPage() {
  return <CityPageTemplate config={annapolisConfig} />;
}